var _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2797,
    height: 2797,
    viewBox: "0 0 2797 2797",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1398.5,
    cy: 1398.5,
    r: 168.041,
    stroke: "#F3B29D",
    strokeWidth: 4,
    strokeDasharray: "2 12"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1398.5,
    cy: 1398.5,
    r: 281.864,
    stroke: "#F3B29D",
    strokeWidth: 4,
    strokeDasharray: "2 12"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1398.5,
    cy: 1398.5,
    r: 430.39,
    stroke: "#F3B29D",
    strokeWidth: 4,
    strokeDasharray: "2 12"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1398.5,
    cy: 1398.5,
    r: 674.694,
    stroke: "#F3B29D",
    strokeWidth: 4,
    strokeDasharray: "2 12"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1398.5,
    cy: 1398.5,
    r: 998.118,
    stroke: "#F3B29D",
    strokeWidth: 4,
    strokeDasharray: "2 12"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1398.5,
    cy: 1398.5,
    r: 1396.5,
    stroke: "#F3B29D",
    strokeWidth: 4,
    strokeDasharray: "2 12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.0f3ae67e55b128c7c86be74564d90ee8.svg";
export { ForwardRef as ReactComponent };